<template>
    <div>
      <v-container fluid grid-list-md text-xs-center id="pendencias-totalizadores">
        <v-row align="center" justify="center" fill-height>
          <v-col cols="12" class="tamanho-cards" v-for="card in totalizadoresOrdenados" :key="card.titulo">
            <v-card class="card-totalizador">
              <v-card-title class="card-totalizador-titulo text-center">
                {{ $tc(card.titulo, 1)}}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-6">
                <v-row class="headline">
                  <template v-if="card.status === 'PENDENCIAS_NDS' && possuiPermissaoApuracaoMassivaAcoesApuracoes">
                    <v-col cols="12" class="text-center pa-0" v-if="!loadingPendenciasAcoesEContratos">{{ quantidadeAcoesApuracoes }}</v-col>
                    <v-col cols="12" class="text-center pa-0" v-if="!loadingPendenciasAcoesEContratos">{{ valToMoney(valorRecebimentoTotalPendenciaAprovacaoND) }}</v-col>
                    <v-col cols="12" class="text-center pt-0 pb-0 text-xs-center accent--text" v-if="loadingPendenciasAcoesEContratos"><v-progress-circular :indeterminate="true"></v-progress-circular></v-col>
                  </template>
                  <template v-if="card.status === 'PENDENCIAS_CONTRATO' && possuiPermissaoApuracaoMassivaContratos">
                    <v-col cols="12" class="text-center pa-0" v-if="!loadingPendenciasAcoesEContratos">{{ quantidadeContratos }}</v-col>
                    <v-col cols="12" class="space" v-if="!loadingPendenciasAcoesEContratos"></v-col>
                    <v-col cols="12" class="text-center pt-0 pb-0 text-xs-center accent--text" v-if="loadingPendenciasAcoesEContratos"><v-progress-circular :indeterminate="true"></v-progress-circular></v-col>
                  </template>
                  <template v-if="card.status === 'PENDENCIAS_ANALISE' && possuiPermissaoPendenciasDeAnalise">
                    <v-col cols="12" class="text-center pa-0" v-if="!loadingPendenciasAnalise">{{ quantidadeEmAnalise }}</v-col>
                    <v-col cols="12" class="space" v-if="!loadingPendenciasAnalise"></v-col>
                    <v-col cols="12" class="text-center pt-0 pb-0 text-xs-center accent--text" v-if="loadingPendenciasAnalise"><v-progress-circular :indeterminate="true"></v-progress-circular></v-col>
                  </template>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-end">
                  <v-tooltip bottom v-if="exibirBotaoExportacao(card)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                      @click="exportarDados(card)"
                      v-on="on"
                      v-bind="attrs"
                      icon
                      density="default">
                        <v-icon>download</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ card.status === 'PENDENCIAS_NDS' ? $t('label.exportar_detalhamento_nd') : $t('label.exportar_detalhamento_anexo') }}
                    </span>
                  </v-tooltip>
                <v-btn icon density="default" @click="abrirModalPendencias(card)">
                  <v-icon>launch</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
<script>
import { mapGetters } from 'vuex';
import TooltipAjudaLista from '@/shared-components/TooltipAjudaLista';
import { pendenciasFluxoAcaoEmAnalise } from '@/common/resources/workflow-acao';
import { convertToMoney } from '@/common/functions/numeric';
import { countRelatorioDetalhamentoNdPendenciaAprovacao, countRelatorioBaseContratosPendenciaAprovacao } from '@/common/resources/magalu-relatorios'; // eslint-disable-line
import { removeEmptyProperties } from '@/common/functions/helpers';
import exportacao from '@/common/functions/exportacao';

export default {
  name: 'DashboardCardsPendenciasTotalizadores',
  components: {
    TooltipAjudaLista,
    pendenciasFluxoAcaoEmAnalise,
  },
  props: {
    possuiPermissaoApuracaoMassivaAcoesApuracoes: Boolean,
    possuiPermissaoApuracaoMassivaContratos: Boolean,
    possuiPermissaoPendenciasDeAnalise: Boolean,
  },
  data() {
    return {
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),

      lista: [],
      statusPadroes: {
        RECEBIMENTO: ['status_entidade.aprovado'],
        PENDENTE_APURACAO: ['status_entidade.apuracao_previa', 'status_entidade.aguardando_apuracao',
          'status_entidade.aguardando_aprovacao', 'status_entidade.em_analise'],
        REJEITADA: ['status_entidade.cancelado', 'status_entidade.reprovado'],
      },
      quantidadeAcoesApuracoes: 0,
      quantidadeContratos: 0,
      quantidadeEmAnalise: 0,
      valorRecebimentoTotalPendenciaAprovacaoND: 0,
      valorRecebimentoTotalPendenciaAnalise: 0,
      loadingPendenciasAnalise: false,
      loadingPendenciasAcoesEContratos: false,
      exibirBotaoDetalhesPendenciaNd: false,
      exibirBotaoDetalhesPendenciaContrato: false,
      exibirBotaoDetalhesPendenciaAnalise: false,
    };
  },
  mounted() {
    this.buscaTotalizadores();
    this.buscarQuantidadePendenciasEmAnalise();
  },
  computed: {
    totalizadoresOrdenados() {
      function compare(a, b) {
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        return 0;
      }
      return this.lista.sort(compare);
    },
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
  },
  methods: {
    exibirBotaoExportacao(card) {
      return card.status === 'PENDENCIAS_CONTRATO' || card.status === 'PENDENCIAS_NDS';
    },
    abrirModalPendencias(card) {
      this.$emit('abrirModalPendencias', card);
    },
    buscaTotalizadores() {
      this.loadingPendenciasAcoesEContratos = true;
      this.workflowAcaoResource.buscarQuantidadePendenciasTotalizadores()
        .then((response) => {
          const dadosRetornados = response.data[0];
          this.quantidadeAcoesApuracoes = dadosRetornados.quantidadeacoesapuracoes;
          this.quantidadeContratos = dadosRetornados.quantidadecontratos;
          this.valorRecebimentoTotalPendenciaAprovacaoND = dadosRetornados.valorrecebimentototalacaoapuracao;
          this.loadingPendenciasAcoesEContratos = false;
          this.exibirBotaoDetalhesPendenciaNd = true;
          this.exibirBotaoDetalhesPendenciaContrato = true;
          this.tratarCards();
          this.tratarOrdem();
        })
        .catch((err) => {
          if (err.data) {
            this.$toast(err.data.error);
          }
        });
    },
    buscarQuantidadePendenciasEmAnalise() {
      const params = {
        is_count: true,
      };
      this.loadingPendenciasAnalise = true;
      pendenciasFluxoAcaoEmAnalise(params, this.$resource)
        .then((res) => {
          const dadosRetornados = res.data[0];
          this.quantidadeEmAnalise = dadosRetornados.quantidadeEmAnalise;
          this.valorRecebimentoTotalPendenciaAnalise = dadosRetornados.valorRecebimentoTotal;
          this.exibirBotaoDetalhesPendenciaAnalise = true;
          this.loadingPendenciasAnalise = false;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    tratarOrdem() {
      this.lista.forEach((item) => {
        if (item.status === 'PENDENCIAS_CONTRATO') {
          item.ordenacao = 2;
        } else if (item.status === 'PENDENCIAS_ANALISE') {
          item.ordenacao = 3;
        } else if (item.status === 'PENDENCIAS_NDS') {
          item.ordenacao = 1;
        }
      });
    },

    tratarCards() {
      const cards = [];
      if (this.possuiPermissaoApuracaoMassivaContratos) {
        cards.push({
          status: 'PENDENCIAS_CONTRATO',
          titulo: this.$tc('label.pendencia_contrato', 1),
        });
      }
      if (this.possuiPermissaoPendenciasDeAnalise) {
        cards.push({
          status: 'PENDENCIAS_ANALISE',
          titulo: this.$tc('label.pendencia_analise', 1),
        });
      }
      if (this.possuiPermissaoApuracaoMassivaAcoesApuracoes) {
        cards.push({
          status: 'PENDENCIAS_NDS',
          titulo: this.$tc('label.pendencia_nds', 1),
        });
      }

      this.lista = cards;
    },
    valToMoney(value) {
      return convertToMoney(value);
    },
    exportarContratoPendenciaAprovacao(filtrosExportacao) {
      countRelatorioBaseContratosPendenciaAprovacao(filtrosExportacao, this.$resource)
        .then((response) => {
          const quantidadeRegistros = response.data;
          if (quantidadeRegistros > 0) {
            let nomeRelatorio = '';
            if (this.isAmbienteEpoca) {
              nomeRelatorio = 'base_contratos_pendencia_aprovacao_epoca';
            } else {
              nomeRelatorio = 'base_contratos_pendencia_aprovacao_magalu';
            }
            this.requestExportacao(filtrosExportacao, nomeRelatorio);
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    exportarNdPendenciaAprovacao(filtrosExportacao) {
      countRelatorioDetalhamentoNdPendenciaAprovacao(filtrosExportacao, this.$resource)
        .then((response) => {
          const quantidadeRegistros = response.data;
          if (quantidadeRegistros > 0) {
            let nomeRelatorio = '';
            if (this.isAmbienteKabum) {
              nomeRelatorio = 'detalhamento_nd_pendencia_aprovacao_kabum';
            } else if (this.isAmbienteEpoca) {
              nomeRelatorio = 'detalhamento_nd_pendencia_aprovacao_epoca';
            } else {
              nomeRelatorio = 'detalhamento_nd_pendencia_aprovacao_magalu';
            }
            this.requestExportacao(filtrosExportacao, nomeRelatorio);
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    exportarDados(card) {
      const filtrosExportacao = {
        id_usuario_logado: this.usuarioLogado.id,
      };

      if (card.status === 'PENDENCIAS_NDS') {
        this.exportarNdPendenciaAprovacao(filtrosExportacao);
      } else if (card.status === 'PENDENCIAS_CONTRATO') {
        this.exportarContratoPendenciaAprovacao(filtrosExportacao);
      }
    },
    requestExportacao(filtros, tipoRelatorio) {
      const filtroTratado = removeEmptyProperties(filtros);
      this.bloquearExportacao = true;

      exportacao.exportar(() => {
        this.bloquearExportacao = false;
      }, tipoRelatorio, this, filtroTratado, 5000, 0);
    },
  },
};
</script>

<style>
  #pendencias-totalizadores .tamanho-cards {
    flex: 0 0 25%;
    max-width: 25%;
    width: 100%;
    padding: 12px;
  }

  @media screen and (max-width: 1420px) {
    #pendencias-totalizadores .tamanho-cards {
      flex: 0 0 33.33%;
      max-width: 33.33%;
      width: 100%;
      padding: 12px;
    }
  }

  @media screen and (max-width: 1060px) {
    #pendencias-totalizadores .tamanho-cards {
      flex: 0 0 100%;
      max-width: 100%;
      width: 100%;
      padding: 12px;
    }
  }

  .card-totalizador-titulo {
    white-space: pre-line;
    word-break: normal;
    flex-direction: column;
  }

  .space {
    height: 2rem;
  }

</style>
